export interface PropertyDetail {
  id: number
  host_user_id: number
  property_type_id: number
  name: string
  description: string
  unique_selling_points: string
  max_guests: number
  use_haup_as_agent: boolean
  unit_size: string
  bedrooms: number
  bathrooms: number
  floor_number: number
  room_number: string
  room_position: string
  has_balcony: boolean
  is_pet_friendly: boolean
  security_deposit: string
  is_active: boolean
  submission_status: string
  completed_steps: number[]
  noise_level: string
  availability_settings: {
    type: string
    available_date?: string
  }
  custom_agent_fee: string
  minimum_rental_duration: string
  published_at: string
  created_at: string
  updated_at: string
  propertyType: {
    id: number
    name: string
    icon_url: string
    is_active: boolean
    display_order: number
    created_at: string
    updated_at: string
  }
  propertyLocation: {
    id: number
    property_id: number
    place_name: string
    address: string
    lat: string
    lng: string
    district: string
    province: string
    postal_code: string
    country: string
    created_at: string
    updated_at: string
  }
  propertyFeatures: Array<{
    id: number
    property_id: number
    feature_id: number
    created_at: string
    featureMaster: {
      id: number
      type: string
      name: string
      icon_url: string
      display_order: number
      created_at: string
      updated_at: string
    }
  }>
  propertyGallery: Array<{
    id: number
    property_id: number
    url: string
    type: string
    sequence: number
    title: string
    description: string
    created_at: string
    updated_at: string
  }>
  propertyPricingOptions: Array<{
    id: number
    property_id: number
    duration_type: string
    monthly_price: string
    is_available: boolean
    created_at: string
    updated_at: string
  }>
  propertySubmissionDocuments: Array<{
    id: number
    property_id: number
    document_type: string
    document_name: string
    file_url: string
    original_filename: string
    verification_status: string
    verified_by_user_id: number
    verified_at: string | null
    rejection_reason: string | null
    created_at: string
    updated_at: string
  }>
  propertyNearbyTransports: Array<{
    id: number
    property_id: number
    transport_station_id: number
    walking_minutes: number
    created_at: string
    transportStation: {
      id: number
      name: string
      type: string
      line_name: string
      created_at: string
      updated_at: string | null
    }
  }>
}

export interface PropertyDetailResponse {
  result: boolean
  data: PropertyDetail
  message: string
}

export class PropertyService {
  private static getAuthHeaders(userToken: string) {
    return {
      Authorization: userToken,
      project: 'haup-stable',
      'Content-Type': 'application/json',
    }
  }

  static async getPropertyDetail(
    draftId: number,
    userToken: string,
  ): Promise<PropertyDetailResponse> {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_TS_RESTFUL_API_URL}/property/detail/${draftId}`,
        {
          method: 'GET',
          headers: this.getAuthHeaders(userToken),
        },
      )

      if (!response.ok) {
        throw new Error('Failed to fetch property details')
      }

      const result = await response.json()
      return result
    } catch (error) {
      console.error('Error fetching property details:', error)
      throw error
    }
  }
}
